import { useParams } from "react-router-dom";
import { AuthenticationContext } from "../../components/authentication/AuthenticationContext";
import React, { useContext, useEffect, useState } from "react";
import { Compilation as CompilationType } from '../../types/Compilation';
import { getCompilationsByDirectory } from "../../components/apis/music-api";
import { Box, Divider, Stack, Typography } from "@mui/material";
import GridCompilation from "../../components/grid-compilation/GridCompilation";
import callApi from "../../components/call-api/call-api";

type CompilationDirectoryProps = {
    directory: string,
}

const CompilationDirectory = () => {
    const params = useParams<CompilationDirectoryProps>();
    const { getAccessToken } = useContext(AuthenticationContext);
    const [ compilations, setCompilations ] = useState<CompilationType[]>();
  
    useEffect(() => {
        setCompilations([]);
        callApi<CompilationType[]>(getCompilationsByDirectory(getAccessToken(), params.directory ?? ''), setCompilations);
    }, [params.directory, getAccessToken]);
    
  return (
    <>
        <Stack>
            <Box>
                <Typography variant='h6'>{params.directory}</Typography>
            </Box>
        </Stack>
        <Stack spacing={3}>
            <Box>
                <Typography variant='h6'>{compilations?.length} Albums</Typography>
            </Box>
            <Box>
                {compilations?.map((compilation, index) => {
                    return (
                        <>
                            {index > 0 && <Divider sx={{ marginTop: '6px', marginBottom: '6px' }} />}
                            <GridCompilation key={`album-${index}`} directory={compilation.directory ?? ''} compilation={compilation} />
                        </>
                    );
                })}
            </Box>
        </Stack>
    </>
  );
}

export default CompilationDirectory;